import {
  Box,
  Button,
  ErrorContent,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalManager,
} from "../../../../components";
import ConfirmationImg from "./assets/confirmation.svg";
import React from "react";
import { useTranslation } from "../../../../hooks";

type Props = {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmCloseModal = ({ show, onClose, onConfirm }: Props) => {
  const translate = useTranslation();

  return (
    <ModalManager onClose={onClose} showModal={show}>
      <Modal wrapContent={true}>
        <ModalHeader />
        <ModalContent>
          <ErrorContent
            image={ConfirmationImg}
            title={translate("owner_info.liveness.confirm_close_modal.title")}
            description={translate(
              "owner_info.liveness.confirm_close_modal.description"
            )}
          />
        </ModalContent>
        <ModalFooter>
          <Box
            flex
            flexDirectionRow
            style={{ gap: "12px" }}
            alignCenter
            justifyCenter
            width100
          >
            <Button secondary onClick={onClose} flexGrow>
              {translate("owner_info.liveness.confirm_close_modal.cta_cancel")}
            </Button>
            <Button onClick={onConfirm} flexGrow>
              {translate("owner_info.liveness.confirm_close_modal.cta_confirm")}
            </Button>
          </Box>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
